import ProductDetail from './components/ProductDetailMain/ProductDetailMain'

export default ProductDetail
